export const formatCurrency = (value: number | string | null | undefined): string => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(parseFloat(String(value || 0)));
};

export const calculateTotalDeductions = (payroll: any): number => {
  return (
    (parseFloat(payroll.deductions) || 0) +
    (parseFloat(payroll.tax) || 0) +
    (parseFloat(payroll.bpjs_employee) || 0)
  );
};
